import {useTCData} from '../../context'

export const DatasetButton = ({updateTeams, item}) => {
  const {setActiveTCDataSet, activeTCDataSetName} = useTCData()
    const handleClick = () => {
        setActiveTCDataSet(item)
        updateTeams(item.data)
    }
  return (
    <div>
      <button className={`button is-small ${activeTCDataSetName === item.setName && "is-danger"}`} onClick={handleClick}>{item.setName}</button>
    </div>
  );
};